export default __webpack_public_path__ + "static/media/LMU_Logo_green.92f7da35.svg";